// import { BluetoothSearchingOutlined } from "@mui/icons-material"

const Links = [
  {
    id: 1,
    title: "Portfolio",
    link: "https://matthew-ehrlich.netlify.app/",
    icon: "<FolderSharedIcon",
  },
  {
    id: 2,
    title: "GitHub",
    link: "https://github.com/Ehrlacker",
  },
  {
    id: 3,
    title: "Youtube",
    link: "https://www.youtube.com/channel/UChw4nAEszy6uc5hJUhkNvAg",
  },

  {
    id: 4,
    title: "LinkedIn",
    link: "https://www.linkedin.com/in/matthew-ehrlich-developer0609/",
  },
  {
    id: 5,
    title: "Blog",
    link: "https://medium.com/@mattcodes06",
  },
  {
    id: 5,
    title: "Podcast",
    link: "https://open.spotify.com/show/4g08UndVH5YfVQWsiXxs9o",
  },
]
export default Links
